import styled from "styled-components";
import { VideocamOff } from "@mui/icons-material";

const OuterWrapper = styled.div(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    paddingInline: "40px",
    [theme.breakpoints.down("sm")]: {
      paddingInline: theme.spacing(2.5),
    },
  };
});

const TabRow = styled.div(({ theme }) => {
  return {
    display: "flex",
    width: "100%",
    justifyContent: "center",
  };
});

const TabButton = styled.button<{ $active?: boolean; $position?: "left" | "center" | "right"; $disabled?: boolean }>(
  ({ $active, $position, $disabled, theme }) => {
    return {
      flex: 1,
      padding: "15px 16px",
      border: "none",
      borderRadius:
        $position === "left"
          ? "25px 0px 0px 0px"
          : $position === "right"
            ? "0px 25px 0px 0px"
            : "0px",
      backgroundColor: $active ? "#CFE6FF" : "#E3E3E3",
      color: $active ? "#0C396D" : "#999999",
      fontWeight: "semibold",
      fontSize: "12px",
      cursor: $disabled ? "not-allowed" : "pointer",
      opacity: $disabled ? 0.4 : 1,
      pointerEvents: $disabled ? "none" : "auto",
      borderBottom: $active ? "5px solid #0C396D" : "5px solid #00000054",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      "& .MuiSvgIcon-root": {
        fontSize: "14px",
        [theme.breakpoints.down("sm")]: {
          fontSize: "11px",
        },
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "10px",
      },
    };
  }
);

const ContentCard = styled.div(({ theme }) => {
  return {
    width: "100%",
    overflow: "hidden",
  };
});

const WebcamContent = styled.div(({ theme }) => {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    width: "100%",
    maxWidth: "640px",
    aspectRatio: "4 / 3",
    overflow: "hidden",
    backgroundColor: "#3978BE",
    borderRadius: "0px 0px 25px 25px",
  };
});

const FeedbackOverlay = styled.div<{ $isValid?: boolean }>(({ theme, $isValid }) => {
  return {
    position: "absolute",
    top: "0px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "8px 18px",

    textAlign: "center",
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: "bold",
    fontSize: "14px",
    zIndex: 15,

    width: "100%",
    display: "flex",
    backgroundColor: "#ffffff",
    color: $isValid ? "#4CAF50" : "#f44336",
    borderBottom: $isValid ? "1px solid #4CAF50" : "1px solid #f44336",
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
    },
  };
});

const Container = styled.div(({ theme }) => {
  return {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  };
});

const ErrorMessage = styled.p<{ $visible?: boolean }>(({ $visible }) => {
  return {
    color: "#ff0000ff",
    visibility: $visible ? "visible" : "hidden",
  };
});

const Actions = styled.div(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    paddingTop: "10px",
    gap: "8px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      gap: "0px",
    },
  };
});

const CountdownNumber = styled.span(({ theme }) => {
  return {
    fontSize: "120px",
    fontWeight: "bold",
    color: "#4CAF50",
    textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
    animation: "pulse 1s ease-in-out",
  };
});

const CapturedPhoto = styled.div<{ $src?: string }>(({ $src }) => {
  return {
    width: "100%",
    maxWidth: "640px",
    aspectRatio: "4 / 3",
    backgroundImage: $src ? `url(${$src})` : "",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    borderRadius: "0px 0px 25px 25px",
  };
});

const EmprendimentoseLabel = styled.div(({ theme }) => ({
  width: "100%",
  padding: "12px 0",
  color: "#0C396D",
  fontWeight: 700,
  fontSize: "14px",
  textAlign: "center",
}));

const CameraIcon = styled(VideocamOff)(({ theme }) => {
  return {
    fontSize: "62px !important",
    color: "#fff",
  };
});

const AnteriorEmptyWrapper = styled.div(() => {
  return {
    textAlign: "center",
    width: "100%",
  };
});

const AnteriorEmptyMessage = styled.div(() => {
  return {
    padding: 0,
    margin: 0,
    flex: 1,
    color: "#fff",
    backgroundColor: "#3978BE",
    minHeight: "300px",
    width: "100%",
    borderRadius: "0px 0px 25px 25px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
});

const UploadDropzone = styled.div(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    backgroundColor: "#3978BE",
    color: "#fff",
    cursor: "pointer",
    gap: "12px",
    fontSize: "14px",
    fontWeight: 500,
    "& .MuiSvgIcon-root": {
      fontSize: "48px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  };
});

const Styles = {
  OuterWrapper,
  TabRow,
  TabButton,
  ContentCard,
  WebcamContent,
  FeedbackOverlay,
  Container,
  CapturedPhoto,
  ErrorMessage,
  Actions,
  CountdownNumber,
  CameraIcon,
  AnteriorEmptyWrapper,
  AnteriorEmptyMessage,
  UploadDropzone,
  EmprendimentoseLabel,
};

export default Styles;
